{
  "INTEGRATION_APPS": {
    "FETCHING": "שליפת אינטגרציות",
    "NO_HOOK_CONFIGURED": "אין {integrationId} אינטגרציות מוגדרות בחשבון זה.",
    "HEADER": "יישומים",
    "COUNT": "{n} integration | {n} integrations",
    "SEARCH_PLACEHOLDER": "חיפוש...",
    "NO_RESULTS": "No results found matching your search",
    "STATUS": {
      "ENABLED": "מופעל",
      "DISABLED": "כבוי"
    },
    "CONFIGURE": "הגדר",
    "ADD_BUTTON": "הוסף קרס חדש",
    "DELETE": {
      "TITLE": {
        "INBOX": "אשר מחיקה",
        "ACCOUNT": "התנתק"
      },
      "MESSAGE": {
        "INBOX": "האם אתה בטוח שברצונך למחוק?",
        "ACCOUNT": "אתה בטוח שאתה מתנתק?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "כן, מחק",
        "ACCOUNT": "כן, התנתק"
      },
      "CANCEL_BUTTON_TEXT": "ביטול",
      "API": {
        "SUCCESS_MESSAGE": "ה-Hook נמחק בהצלחה",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      }
    },
    "LIST": {
      "FETCHING": "הוצאת קרס אינטגרציה",
      "INBOX": "תיבת הדואר הנכנס",
      "ACTIONS": "פעולות",
      "DELETE": {
        "BUTTON_TEXT": "מחק"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "בחר תיבת דואר",
          "PLACEHOLDER": "בחר תיבת דואר"
        },
        "SUBMIT": "צור",
        "VALIDATING_OPENAI": "Validating with OpenAI...",
        "CANCEL": "ביטול"
      },
      "API": {
        "SUCCESS_MESSAGE": "קרס אינטגרציה נוסף בהצלחה",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "התחבר"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "התנתק"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow היא פלטפורמה לעיבוד שפה טבעית לבניית ממשקי שיחה. שילובה עם {installationName} מאפשר לבוטים לטפל בשאילתות תחילה ולהעביר אותן לסוכנים בעת הצורך. זה עוזר לאמת לידים ולהפחית את עומס העבודה של הסוכן על ידי מענה על שאלות נפוצות. כדי להוסיף את Dialogflow, צור חשבון שירות ב-Google Console ושתף את פרטי הכניסה. עיין בתיעוד לפרטים"
    }
  }
}
